import { Button } from '@mui/material';
import AddEvaluationManagerFormLanding from '../../../views/appraisal/evaluation/addEvaluationSelf/AddEvaluationManagerFormLanding';
import ToolTip from '../../ToolTip/ToolTip';
import AddEvaluationSelfFormLanding from '../../../views/appraisal/evaluation/addEvaluationSelf/AddEvaluationSelfFormLanding';

const handleToolTip = (value) => {
  return <ToolTip content={value} expand={value} />;
};

const evaluationStatusesJson = [
  { id: 0, name: 'Pending' },
  { id: 1, name: 'Self Appraisal Completed' },
  { id: 2, name: 'Manager Appraisal Completed' },
];

export const usersListAppraisalCycle = (selectedCycleId, cycleName, api, dispatchParams) => [
  {
    field: 'sl_no',
    headerName: 'Sl No',
    width: 70,
  },
  {
    field: 'appraisal_cycle_name',
    headerName: 'Cycle Name',
    width: 250,
    valueGetter: (params) => cycleName,
  },
  {
    field: 'name',
    headerName: 'User Name',
    width: 240,
  },
  {
    field: 'evaluation_status',
    headerName: 'Status',
    width: 250,
    valueGetter: (params) => {
      return evaluationStatusesJson.find((sts) => sts.id == params.row?.evaluation_status)?.name || 'Other';
    },
  },
  {
    field: 'managerAppraisalStartDate',
    headerName: 'Manager Appraisal Start Date',
    width: 210,
  },
  {
    field: 'managerAppraisalEndDate',
    headerName: 'Manager Appraisal End Date',
    width: 200,
  },
  {
    field: 'isManagerAppraisalNeeded ',
    headerName: 'Manager Appraisal Needed',
    width: 200,
    valueGetter: (params) => {
      return params.row?.isManagerAppraisalNeeded ? 'Yes' : 'No';
    },
  },
  {
    field: 'isManagerAppraisalActive ',
    headerName: 'Appraisal Deadline Status',
    width: 230,
    valueGetter: (params) => {
      return params.row?.isManagerAppraisalActive ? 'Active' : 'Date Expired/No Action Needed ';
    },
  },
  {
    field: 'managerAction',
    headerName: 'Action',
    width: 250,
    renderCell: (params) => {
      const mangagerAppraisalNeeded = params.row?.isManagerAppraisalNeeded;
      // const mangagerAppraisalNeeded =false //OTHER WISE SELF APPRAISAL API ERROR BCZ THE MANGERER NOT ASSIGFNED THIS CYCLE FOR ASSIGNED
      const viewOnly = !params.row?.isManagerAppraisalNeeded || params.row?.evaluation_status == 2;

      return mangagerAppraisalNeeded ? (
        <AddEvaluationManagerFormLanding
          userID={params.row.userID}
          id={selectedCycleId}
          title={cycleName}
          afterFormSubmissionApi={api}
          AfterFormdispatchParams={dispatchParams}
          extraDisable={viewOnly ? false : !params.row?.isManagerAppraisalActive || params.row?.evaluation_status == 0}
          isAdmin={false}
          viewOnly={viewOnly} //IF THE MANAGER APPRASIAL COMPLETED 2 IT IS CONVERTED TO VIEW MODE or THE NO MANGER APPEAISAL NEEDED THEN ALSO VIEW MODE
        />
      ) : (<AddEvaluationSelfFormLanding
       userID={params.row.userID}
        id={selectedCycleId}
        title={cycleName}
        // afterFormSubmissionApi={api}
        // AfterFormdispatchParams={SelfAppraisalDispatchParams}
        extraDisable={params.row?.evaluation_status == 0}
        viewOnly={true}
      />);
    },
  },
];
